/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import { FormControl, Input, InputLabel } from 'src/common/ui/components';
import {
  formControlStyles,
  inputStyles,
  errorStyles,
} from 'src/components/pages/providers/Provider.Form.styles';

export const TextInput = ({
  label,
  name,
  onChange,
  placeholder,
  required = false,
  type = 'text',
  value,
  error,
}: {
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value: string | null;
  error?: string;
}) => {
  const [touched, setTouched] = useState(false);
  const touchedAndError = touched && !!error;
  return (
    <FormControl css={formControlStyles} required={required} error={touchedAndError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Input
        css={inputStyles}
        id={name}
        name={name}
        onChange={onChange}
        onBlur={() => !touched && setTouched(true)}
        placeholder={placeholder}
        type={type}
        value={value || ''}
        error={touchedAndError}
      />
      {touchedAndError && <div css={errorStyles}>{error}</div>}
    </FormControl>
  );
};
